import { useState } from "react";
import { useQuery } from "@apollo/client/react";

import { UpdateEmailAddressPage as Component } from "../../../components/pages/patientHt/UpdateEmailAddressPage";
import type { HtPatient } from "../../../components/pages/patientHt/UpdateEmailAddressPage";
import { useMutation } from "@apollo/client/react";
import { GQLMutation } from "@rx-cs-system/schema";
import { UPDATE_HT_USER_EMAIL_ADDRESS } from "../../../graphql/mutations";
import { useLocation, useNavigate, Location } from "react-router";
import { useValidation } from "../../../hooks/useValidation";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { GET_MODAL_STATE } from "../../../graphql/queries";
import { LocalQuery } from "../../../cache";
import { closeModal } from "../../../graphql/local-mutations";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const UpdateEmailAddressPage = () => {
  const navigate = useNavigate();
  const location: Location<HtPatient> = useLocation();
  const htPatient = location.state;

  useCheckUserRole();

  const { data: modalData } = useQuery<LocalQuery>(GET_MODAL_STATE);

  const { snackBar, showErrorSnackBar } = useSnackBar();

  const [updatedEmailAddress, { loading }] = useMutation<GQLMutation>(
    UPDATE_HT_USER_EMAIL_ADDRESS,
    {
      onCompleted: (result) => {
        closeModal("confirmInput");
        navigate(`/patient_ht/${htPatient.id}`, {
          state: {
            emailOnChanged: {
              id: result.updateHtUserEmailAddress.id,
              email: result.updateHtUserEmailAddress.email,
              message: "メールアドレスを更新しました。",
            },
          },
        });
      },
      onError: () => {
        showErrorSnackBar(
          "メールアドレスの更新に失敗しました。DTFチームにお問い合わせください。",
        );
        closeModal("confirmInput");
      },
    },
  );

  const [proposedEmail, setProposedEmail] = useState("");
  const {
    errors: validationErrors,
    isFormValid,
    setTouched,
  } = useValidation(
    {
      proposedEmail: {
        value: proposedEmail,
        rules: { email: true },
      },
    },
    [proposedEmail],
  );

  const onUpdateEmailAddressClick = (email: string) => {
    updatedEmailAddress({
      variables: {
        input: {
          id: htPatient.id,
          email,
        },
      },
    });
  };

  return (
    <Component
      htPatient={{
        id: htPatient.id,
        email: htPatient.email,
      }}
      onUpdateEmailAddressClick={onUpdateEmailAddressClick}
      validationErrors={validationErrors}
      setProposedEmail={(email: string) => {
        setTouched("proposedEmail");
        setProposedEmail(email);
      }}
      {...{
        proposedEmail,
        isFormValid,
        processing: loading,
        snackBar,
        onCancelButtonClick: () => {
          navigate(`/patient_ht/${htPatient.id}`);
        },
      }}
      isOpen={modalData?.modalState.confirmInput.isOpen || false}
    />
  );
};
